/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-13, 12:21:13
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-05-08, 12:23:04
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import React from 'react';
import { Tag } from 'antd';
import Classnames from "classnames";
import { Icon } from 'react-fa';
import PropTypes from 'prop-types';

import './style.sass';

const State =  props => 
  (<Tag className={Classnames({ 'state-success' : props.type, 'state-error' : !props.type })}>
    <Icon name={Classnames({ times: !props.type, check: props.type  })} />
  </Tag>)

State.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number
  ])
}

export default State;



// WEBPACK FOOTER //
// ./src/rcapp/components/layout/state/index.js